export default class requestMiddlewareService {
    static requestLimit = 5;
    static timeFrame = 20000;
    static requestCount = 0;
    static firstRequestTime: null | number = null;

    static checkRequestLimit() {
        const currentTime = Date.now();

        // Если это первый запрос, инициализируем время
        if (this.firstRequestTime === null) {
            this.firstRequestTime = currentTime;
        }

        // Проверяем, не истекло ли время
        if (currentTime - this.firstRequestTime > this.timeFrame) {
            // Сбрасываем счетчик и время
            this.requestCount = 0;
            this.firstRequestTime = currentTime;
        }

        // Проверяем лимит запросов
        if (this.requestCount >= this.requestLimit) {
            throw new Error('request_limit');
        }

        // Увеличиваем счетчик запросов
        this.requestCount++;
    }
}